import { QueryKey } from '@/configs/queryKeys';
import { Attachment, ForeignLanguage, BaseEntity } from '@/types/types';
import EntityApi from './EntityApi';

export enum ContentType {
	TEXT = 'text',
	IMAGE = 'image',
	ELEMENT = 'heading',
}

type ContentImage = Pick<Attachment, 'id' | 'path'>;

export interface Content extends BaseEntity {
	slug: string;
	type: ContentType;
	content: string;
	image?: ContentImage;
	translations: Partial<
		Record<
			ForeignLanguage,
			{
				content: string;
				image?: ContentImage;
			}
		>
	>;
}

class ContentApi extends EntityApi<Content> {
	constructor() {
		super(QueryKey.contents);
	}
}

export default new ContentApi();
